var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ve-chart", {
    attrs: {
      data: _vm.data,
      settings: _vm.settings,
      "y-axis": _vm.yAxis,
      "x-axis": _vm.xAxis,
      grid: _vm.grid,
      legend: _vm.legend
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }